import React, { useState, useEffect } from 'react'
import { APILoggerDetail, buildAPILoggerDetail } from '../../models/APILoggerDetail';
import { Select, MenuItem, ToggleButtonGroup, ToggleButton } from "@mui/material"
import { GraphTemplate } from '../../models/GraphTemplateModel'
import { FormattedMessage, useIntl } from 'react-intl';
import { flowRateUnits, flowUnits, pressureUnits } from '../../Utils/UnitConverters'
interface Props {
    colors: {
        red: Array<string>
        yellow: Array<string>
        green: Array<string>
        brown: Array<string>
        blue: Array<string>
        orange: Array<string>
        purple: Array<string>

    }
    name: string
    color: string
    loggers: Array<APILoggerDetail>
    currentUnit: string
    type: string
    handleHideLoggerChannel: (serial: number, channel: string) => void
    handleUnitChange: (value : string, channel: string) => void
    unitsAndValues: Array<GraphTemplate>
    handleGraphTypeChange: (value:string, channel:string) => void
}
const GraphChannelDisplay: React.FC<Props> = ({ colors, name, color, loggers, currentUnit, type, handleHideLoggerChannel, unitsAndValues, handleUnitChange, handleGraphTypeChange }) => {

    const intl = useIntl()
    useEffect(() => {
        let channelTemp = ""
        let graphTypeTemp = ""
        if (name === intl.formatMessage({ id: 'Channel A' }) || name === intl.formatMessage({ id: 'Flow A' })) {
            channelTemp = 'A'
            graphTypeTemp = unitsAndValues[0].graphSettings.flowAGraphType
        } else if (name === intl.formatMessage({ id: 'Totaliser A' })) {
            channelTemp = 'AT'
            graphTypeTemp = unitsAndValues[0].graphSettings.flowATotalGraphType
        } else if (name === intl.formatMessage({ id: 'Consumption A' })) {
            channelTemp = 'AC'
            graphTypeTemp = unitsAndValues[0].graphSettings.flowAConsumptionGraphType
        } else if (name === intl.formatMessage({ id: 'Channel B' }) || name === intl.formatMessage({ id: 'Flow B' })) {
            channelTemp = 'B'
            graphTypeTemp = unitsAndValues[0].graphSettings.flowBGraphType
        } else if (name === intl.formatMessage({ id: 'Totaliser B' })) {
            channelTemp = 'BT'
            graphTypeTemp = unitsAndValues[0].graphSettings.flowBTotalGraphType
        } else if (name === intl.formatMessage({ id: 'Consumption B' })) {
            channelTemp = 'BC'
            graphTypeTemp = unitsAndValues[0].graphSettings.flowBConsumptionGraphType
        } else if (name === intl.formatMessage({ id: 'Channel C' }) || name === intl.formatMessage({ id: 'Pressure C' })) {
            channelTemp = 'C'
            graphTypeTemp = unitsAndValues[0].graphSettings.pressureCGraphType
        } else if (name === intl.formatMessage({ id: 'Channel D' }) || name === intl.formatMessage({ id: 'Pressure D' })) {
            channelTemp = 'D'
            graphTypeTemp = unitsAndValues[0].graphSettings.pressureDGraphType
        } else if (name === intl.formatMessage({ id: 'Channel E' }) || name === intl.formatMessage({ id: 'Pressure E' })) {
            channelTemp = 'E'
            graphTypeTemp = unitsAndValues[0].graphSettings.pressureEGraphType
        }
        setChannel(channelTemp)
        setGraphType(graphTypeTemp)
    }, [unitsAndValues])

        
        
    
    const [tooltip, setShowTooltip] = useState<boolean>(false)
    const [channel, setChannel] = useState<string>("")
    const [graphType, setGraphType] = useState<string>("")
    return (
        <div onMouseOver={(): void => setShowTooltip(true)} onMouseLeave={(): void => setShowTooltip(false)} style={{ position: "relative", width: "200px" }} >
            <div
                style={{
                    display: "flex",
                    borderLeft: `6px solid ${colors[color][0]}`,
                    boxShadow: "2px 2px 10px #00000060",
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    borderBottomLeftRadius: tooltip ? "0px" : "5px",
                    borderBottomRightRadius: tooltip ? "0px" : "5px",
                    alignItems: "center",
                    padding: "6px 12px",
                    marginRight: "20px"
                }}>


            <p style={{ margin: "2px 0 0 0", textAlign: "center", width: "100%" }}>{name}</p>
        </div>
            {tooltip && <div
                style={{
                    backgroundColor: '#eeeeee',
                    marginLeft: "5px",
                    paddingTop: "10px",
                    position: "absolute",
                    width: "175px",
                    borderLeft: "1px solid #d9d9d9",
                    borderRight: "1px solid #d9d9d9",
                    borderBottom: "1px solid #d9d9d9",
                    borderBottomLeftRadius: "5px",
                    borderBottomRightRadius: "5px",
                    boxShadow: "2px 2px 10px #00000060"
                }}>{loggers.map((logger, index) => {
                    const device = unitsAndValues.filter(dev => dev.serial === logger.Serial)[0]

                    if (!(logger.ChannelsAvail & 0x01) && channel === 'A') return
                    if (!(logger.ChannelsAvail & 0x01) && channel === 'AT') return
                    if (!(logger.ChannelsAvail & 0x01) && channel === 'AC') return
                    if (!(logger.ChannelsAvail & 0x02) && channel === 'B') return
                    if (!(logger.ChannelsAvail & 0x02) && channel === 'BT') return
                    if (!(logger.ChannelsAvail & 0x02) && channel === 'BC') return
                    if (!(logger.ChannelsAvail & 0x04) && channel === 'C') return
                    if (!(logger.ChannelsAvail & 0x08) && channel === 'D') return
                    if (!(logger.ChannelsAvail & 0x10) && channel === 'E') return



                    let colorBG = colors[color][index]
                    console.log(device)
                    if (device) {
                        if (!device.graphSettings.flowAVisible && channel === 'A') {
                            colorBG = 'gray'
                        }
                        if (!device.graphSettings.flowATotalVisible && channel === 'AT') {
                            colorBG = 'gray'
                        }
                        if (!device.graphSettings.flowAConsumptionVisible && channel === 'AC') {
                            colorBG = 'gray'
                        }
                        if (!device.graphSettings.flowBVisible && channel === 'B') {
                            colorBG = 'gray'
                        }
                        if (!device.graphSettings.flowBTotalVisible && channel === 'BT') {
                            colorBG = 'gray'
                        }
                        if (!device.graphSettings.flowBConsumptionVisible && channel === 'BC') {
                            colorBG = 'gray'
                        }
                        if (!device.graphSettings.pressureCVisible && channel === 'C') {
                            colorBG = 'gray'
                        }
                        if (!device.graphSettings.pressureDVisible && channel === 'D') {
                            colorBG = 'gray'
                        }
                        if (!device.graphSettings.pressureEVisible && channel === 'E') {
                            colorBG = 'gray'
                        }
                    }
                    return (<div key={logger.Serial} onClick={(): void => handleHideLoggerChannel(logger.Serial, channel)} style={{ display: "flex", justifyContent: "center", width: "100%", marginRight: "20px", cursor: "pointer" }}>
                        <div style={{ backgroundColor: colorBG, width: "20px", height: "20px", margin: "5px 10px 0 0" }} >
                    </div>
                    <p style={{ marginTop: "3px" }}>{logger.Serial}</p>
                    </div>)

                })}
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <div>
                        <p style={{ textAlign: "center" }}><FormattedMessage id="Display As" /></p>
                        <ToggleButtonGroup style={{ margin: "-8px 0 10px 0" }} onChange={(e):void => handleGraphTypeChange(e.target.id, channel) }>
                            <ToggleButton value='spline'  size="small" style={{ backgroundColor: graphType === 'spline' ? colors[color][0] : 'inherit'} }>
                                <span id="spline" style={{ color: graphType === 'spline' ? 'white' : 'inherit', textDecoration: graphType === 'spline' ? 'underline' : 'none' }}><FormattedMessage id="Line" /></span>
                            </ToggleButton>
                            <ToggleButton value='bar' size="small" style={{ backgroundColor: graphType !== 'spline' ? colors[color][0] : 'inherit' }}>
                                <span id="bar" style={{ color: graphType !== 'spline' ? 'white' : 'inherit', textDecoration: graphType !== 'spline' ? 'underline' : 'none' }}><FormattedMessage id="Bar" /></span>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    {type === 'pressure' && pressureUnits.includes(currentUnit) ?  <div>
                        <p style={{ textAlign: "center" }}><FormattedMessage id="Unit" /></p>

                        <Select
                            size="small"
                            value={currentUnit}
                            style={{ margin: "-8px 0 10px 0" }}
                            onChange={(e): void => handleUnitChange(e.target.value, channel)}
                        >
                            {pressureUnits.map((unit, idx) => (<MenuItem key={idx} value={unit.value}>{unit.name}</MenuItem>))}
                        </Select>
                    </div> :
                        
                    <div>
                        {type !== 'pressure' && <div>
                            <p style={{ textAlign: "center" }}><FormattedMessage id="Unit" /></p>
                            <Select
                                size="small"
                                value={currentUnit}
                                style={{ margin: "-8px 0 10px 0" }}
                                onChange={(e): void => handleUnitChange(e.target.value, channel)}
                            >
                                {type === 'flow' && flowRateUnits.map((unit, idx) => (<MenuItem key={idx} value={unit.value}>{unit.name}</MenuItem>))}
                                {type === 'total' && flowUnits.map((unit, idx) => (<MenuItem key={idx} value={unit.value}>{unit.name}</MenuItem>))}
                                {type === 'consumption' && flowUnits.map((unit, idx) => (<MenuItem key={idx} value={unit.value}>{unit.name}</MenuItem>))}
                            </Select>
                        </div>}
                    </div>}
                </div>
            </div>}
            
        </div>
    )
}
export default GraphChannelDisplay